import { useRef } from "react"
import { Box, HStack, Stack } from "@chakra-ui/react"

import { DealManagerNavBar, DealManagerNavigation, Toaster } from "@/components"
import { useAuth } from "@/contexts"

import { useDealManagerClients } from "@/hooks"
import { Outlet } from "react-router-dom"
import { PortalRole } from "@/types"

export const DealManagerLayout = () => {
  const { user } = useAuth()
  const sectionRef = useRef<HTMLDivElement>(null)

  if (!user) return <div>Loading...</div>
  if (user.userType !== PortalRole.ESO_PERSON) return <div>Unauthorized</div>

  return (
    <>
      <HStack w="100%" h="100vh" gap={0}>
        <Box w="50px" h="100%">
          <DealManagerNavigation />
        </Box>

        <Stack w="calc(100% - 50px)" h="100%" gap={0}>
          <DealManagerNavBar />
          <Stack ref={sectionRef} bg="page.bg" w="100%" h="100%" overflowY="auto" gap={0}>
            <Outlet />
          </Stack>
        </Stack>
      </HStack>
      <Toaster />
    </>
  )
}